// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_play__WfmCW{
    /* display: flex;
    justify-content: flex-start;
    align-items:center;
    height:auto; */
    padding: 13px;
    padding-right:12px;
    /* background: #ccc; */
    border-radius: 50%;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
}

.styles_player__o2p4d {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items:center;
    height:auto;

    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: auto;
    padding: 0 10px;
  }
  .styles_controls__fQmAn {
    display: flex;
    justify-content: flex-start;
    align-items:center;
    /* width:90%; */
    width:100%;
    height:auto;
    direction:ltr;
  }
  .styles_icon__2J--E{
    /* margin-right:5px; */
    cursor:pointer;
  }`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AudioPlayerUnActive/styles.module.css"],"names":[],"mappings":"AAAA;IACI;;;kBAGc;IACd,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;;IAEX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,WAAW;IACX,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,cAAc;EAChB","sourcesContent":[".play{\n    /* display: flex;\n    justify-content: flex-start;\n    align-items:center;\n    height:auto; */\n    padding: 13px;\n    padding-right:12px;\n    /* background: #ccc; */\n    border-radius: 50%;\n    width: 45px;\n    height: 45px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n}\n\n.player {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items:center;\n    height:auto;\n\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    height: auto;\n    padding: 0 10px;\n  }\n  .controls {\n    display: flex;\n    justify-content: flex-start;\n    align-items:center;\n    /* width:90%; */\n    width:100%;\n    height:auto;\n    direction:ltr;\n  }\n  .icon{\n    /* margin-right:5px; */\n    cursor:pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"play": `styles_play__WfmCW`,
	"player": `styles_player__o2p4d`,
	"controls": `styles_controls__fQmAn`,
	"icon": `styles_icon__2J--E`
};
export default ___CSS_LOADER_EXPORT___;
